import {getApiUrl} from '@/api/common-utils';
import {BaseApi} from '../base-api';
import KeywordOverviewApi from './overview/overview-api';

// export const OVERVIEW_DETAIL_API = new BacklinkOverviewApi(getApiUrl(BaseApi.KEYWORD_ENDPOINT, '/api'));
export const KEYWORD_API = new KeywordOverviewApi(getApiUrl(BaseApi.KEYWORD_ENDPOINT, '/'));
